import React, {useState, useEffect} from "react";
import { Helmet } from "react-helmet";
import {Header, Titulo} from './../elementos/Header';
import BtnRegresarValida from "../elementos/BtnRegresarValida";
import FormularioViaje from "./FormularioCreaViaje";
import FormularioViajePasajero from "./FormularioCreaViajePasajero";
import {ContenedorDoble} from '../elementos/ElementosDeFormularioCreaViaje';
//Importacion para sesion de usuario
import {auth} from '../firebase/firebaseConfig';
import {signOut} from 'firebase/auth';
import useObtenerAdmin from '../hooks/useObtenerAdmin'
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import { useAuth } from './../contextos/AuthContext';
import {ContenedorNavegador, BotonNavegador} from './../elementos/ElementosApp';

const  CrearViaje = () => {

    const [itinerario, cambiarItinerario] = useState([]); 
    const [listadoPasajeros, cambiarListadoPasajeros] = useState([]); 
    const [fechahoraviaje, cambiarFechahoraviaje] = useState (null);
    const [cliente, cambiarCliente] = useState ('Seleccione Cliente');
    const [VerFormularioViaje, cambiarVerFormularioViaje] = useState(true);
    const viaje = useState([]);
// variables de sesion de usuario
    const navigate = useNavigate();
    const {usuario} = useAuth();
    const [TipoUsuario, cambiarTipoUsuario] = useState([]);
    const uid = usuario.uid
    const UsarioLog = useObtenerAdmin({uid});
    const [Escliente, cambiarEscliente] = useState(true);

//useEffect de usuario
useEffect (()=>{    
  if (UsarioLog.cliente === 'undefined' || UsarioLog.cliente === 'Sin Permisos' || UsarioLog.cliente === null)
  {cambiarTipoUsuario('salir')}
  else
  {    
    if (UsarioLog.cliente === 'R.T ESTRELLA' || UsarioLog.cliente === 'R.T Estrella')
      {cambiarTipoUsuario('admin')}
    else
      {
        if (Number(UsarioLog.numero) > 0)
        {{cambiarTipoUsuario('conductor')}
      }
        else{
          {cambiarTipoUsuario('cliente')}
      }
        
      }
  }
  },[UsarioLog]);
  
  
  useEffect (()=>{    
 
    if (UsarioLog.cliente === 'R.T ESTRELLA' || UsarioLog.cliente === 'R.T Estrella')
      {cambiarTipoUsuario('admin')
      console.log('entra admin')
      cambiarEscliente(false)

    }
    else
      {{cambiarTipoUsuario('cliente')}
      console.log('entra cliente')
      console.log(UsarioLog.cliente)

    }
    if (Number(UsarioLog.numero) > 0)
    {cambiarTipoUsuario('conductor')
    console.log('entra conductor')
    cambiarEscliente(false)

  } 
    
  },[UsarioLog]);


    return ( 
        <>
        <Helmet>
        <title> Crear Traslado </title>
        </Helmet>
  
            <Header>


            <ContenedorNavegador>
                <BtnRegresarValida
                VerFormularioViaje={VerFormularioViaje}
                ></BtnRegresarValida>


      
      <BotonNavegador to="/listar-activos">Listar</BotonNavegador>
      <BotonNavegador to="/listar-terminados">Buscar</BotonNavegador>
      </ContenedorNavegador>  



                <Titulo>Crear Traslado</Titulo>         
            </Header>
            
            <ContenedorDoble>
            
            <FormularioViajePasajero
                cliente={cliente}
                cambiarCliente={cambiarCliente}
                itinerario={itinerario} 
                cambiarItinerario={cambiarItinerario} 
                listadoPasajeros={listadoPasajeros} 
                cambiarListadoPasajeros={cambiarListadoPasajeros}
                fechahoraviaje={fechahoraviaje}
                cambiarFechahoraviaje={cambiarFechahoraviaje}
                cambiarVerFormularioViaje={cambiarVerFormularioViaje}
                Escliente={Escliente}
                UsarioLog={UsarioLog}
             >
             </FormularioViajePasajero>
             <div hidden={VerFormularioViaje}>
             <FormularioViaje
                cliente={cliente}
                cambiarCliente={cambiarCliente}
                viaje={viaje}
                itinerario={itinerario} 
                cambiarItinerario={cambiarItinerario} 
                listadoPasajeros={listadoPasajeros} 
                cambiarListadoPasajeros={cambiarListadoPasajeros} 
                fechahoraviaje={fechahoraviaje}
                cambiarFechahoraviaje={cambiarFechahoraviaje}
                cambiarVerFormularioViaje={cambiarVerFormularioViaje}
                Escliente={Escliente}
                UsarioLog={UsarioLog}
            >
            </FormularioViaje>
            </div>
            </ContenedorDoble>
        
            

        
 
        </>
     );
}
 
export default  CrearViaje;




